import * as React from 'react'
import { useFlags } from 'launchdarkly-react-client-sdk'

import { filterOptionsHelper } from '../../../../helpers/filterOptionsHelper'

import { StyledTable, TableWrapper } from './BrandOrderListNew.style'
import BrandOrderListNewItem from './BrandOrderListNewItem'

export interface BrandOrderListNewProps {
  projects?: any
  refetch?: () => void
  brandOrderUuid?: string
  projectsLoading?: boolean
  searchTerm?: string
  optionDropdownData?: any
  projectsCount: number
  sortStateCallback: (data: any) => void
}

const BrandOrderListNew: React.FC<BrandOrderListNewProps> = ({
  projects,
  refetch,
  brandOrderUuid,
  optionDropdownData,
  sortStateCallback,
}) => {
  const [sortState, setSortState] = React.useState({
    name: '',
    seq: '',
  })

  React.useEffect(
    () => {
      sortStateCallback(sortState)
    },
    [sortState]
  )

  const flags = useFlags()
  const newSorting = flags['brand-dashboard-new-sorting']

  const TableHeader: React.FC<{ value: string; sortKey: string }> = ({ value, sortKey }) => {
    return (
      <>
        {filterOptionsHelper(optionDropdownData, value) && (
          <th
            className={`status-header ${
              sortState.name === sortKey && sortState.seq !== '' ? '' : 'blank'
            } ${sortState.name === sortKey && sortState.seq === 'asc' ? 'reverse' : ''}`}
            onClick={() => {
              newSorting &&
                setSortState({
                  name: sortKey,
                  seq: sortState.seq === '' ? 'asc' : sortState.seq === 'asc' ? 'desc' : '',
                })
            }}
          >
            {value === 'Payment Type' ? 'PAYMENT' : value.toUpperCase()} {arrowDown}
          </th>
        )}
      </>
    )
  }
  const arrowDown = (
    <svg xmlns="http://www.w3.org/2000/svg" width="9" height="7" viewBox="0 0 9 7" fill="none">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.40078 6.19995C4.19686 6.19995 4.00324 6.11274 3.87124 5.96142L0.165988 1.71408C-0.0823801 1.42937 -0.0466402 1.00256 0.245819 0.760778C0.538278 0.518992 0.976705 0.553786 1.22507 0.838493L4.40078 4.47882L7.57649 0.838493C7.82486 0.553786 8.26329 0.518992 8.55574 0.760778C8.8482 1.00256 8.88394 1.42937 8.63558 1.71408L4.93032 5.96142C4.79832 6.11274 4.6047 6.19995 4.40078 6.19995Z"
        fill="#1E1E21"
      />
    </svg>
  )

  return (
    <>
      <TableWrapper>
        <StyledTable>
          <thead>
            <tr>
              {optionDropdownData &&
                optionDropdownData.map(data => {
                  return (
                    data && <TableHeader value={data.name} sortKey={data.value} key={data.name} />
                  )
                })}
              <th />
            </tr>
          </thead>
          <tbody>
            <tr className="separator" />
          </tbody>
          <tbody>
            {projects &&
              projects.map((project, index) => {
                return (
                  <BrandOrderListNewItem
                    project={project}
                    key={index}
                    refetch={refetch}
                    brandOrderUuid={brandOrderUuid}
                    optionDropdownData={optionDropdownData}
                  />
                )
              })}
          </tbody>
        </StyledTable>
      </TableWrapper>
    </>
  )
}

export default React.memo(BrandOrderListNew)



// WEBPACK FOOTER //
// ./src/components/BrandDashboard/components/BrandOrderListNew/BrandOrderListNew.tsx